import axios from 'axios'

export const instance = axios.create({
    baseURL: 'https://wsyj23h5j3.execute-api.us-east-1.amazonaws.com/prod/inspire-africa-tickets',
    headers: {
        'Content-Type': 'application/json'
    },
})

instance.interceptors.request.use(
    async (config) => {
        let token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// instance.interceptors.response.use(
//     (res) => {
//         return res
//     },
//     (error) => {
//         if (error.response) {
//             if (error.response.status !== 401) {
//                 reportError(error)
//             }

//             // Token was expired
//             if (error.response.status === 401 || error.response.code === 'ERR_NETWORK') {
//                 handleSignout()
//             }
//         }
//         // Token was expired
//         if (error.status === 401 || error.code === 'ERR_NETWORK') {
//             handleSignout()
//         }

//         return Promise.reject(error)
//     },
// )

export default instance
